$(document).ready(function () {
    $('.new-print').on('click', function () {
        const $content = $('.news-details');
        if ($content.length === 0) return;

        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; padding: 20px; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write($content.html());
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    });
});
